import React, {useEffect, useState} from "react";
import {Col, InputNumber, Select} from "antd";
import _ from "lodash";
import {
    CityFilter,
    CompanyFilter,
    CourierTypeFilter,
    SubCompanyFilter,
    PoolFilter
} from "../../_defaultComponents/FilterComponents";
import {usePoolCompanies} from "../../../hooks/usePoolCompanies";
import {EligibleCourierSelect} from "../../_defaultComponents/EligibleCourierSelect/EligibleCourierSelect";
import {useTranslation} from "react-i18next";
import {courierStatusColors, courierStatuses} from "../../../constants/constants";
import {useStore} from "../../../hooks/useStore";

const Filters = ({setCurrentPage, filters, setFilters, data = [], dataLoading = false}) => {
    const {t} = useTranslation();
    const stores = useStore();
    const {filterCompany, isLoading} = usePoolCompanies(filters.pool);

    useEffect(() => {
        if (filters.pool) {
            setFilters(prev => ({
                ...prev,
                companyId: undefined,
                subcompanyId: undefined,
                preferredCourierId: undefined,
                forceCourierId: undefined
            }));
        }
    }, [filters.pool, setFilters]);

    return (
        <React.Fragment>
            <Col xs={24} sm={12} md={6} lg={4} xl={3}>
                <CityFilter
                    showAllOption={false}
                    value={filters.city}
                    allowClear={true}
                    onChange={value => {
                        setFilters({
                            ...filters,
                            city: value,
                            pool: undefined,
                            companyId: undefined,
                            subcompanyId: undefined
                        });
                        setCurrentPage(1);
                    }}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={4} xl={5}>
                <PoolFilter
                    showAllOption={false}
                    value={filters.pool}
                    allowClear={true}
                    city={filters.city}
                    onChange={value => {
                        setFilters({
                            ...filters,
                            pool: value
                        });
                        setCurrentPage(1);
                    }}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={4} xl={4}>
                <CompanyFilter
                    showAllOption={false}
                    showPoolOption={false}
                    value={filters.companyId}
                    city={filters.city}
                    onChange={value => {
                        setFilters({
                            ...filters,
                            companyId: value,
                            subcompanyId: undefined,
                            forceCourierId: undefined,
                            preferredCourierId: undefined,
                            courierType:
                                stores?.appStore?.companyListFilter?.find(c => c._id === value)
                                    ?.courierTypes?.[0] || undefined
                        });
                        setCurrentPage(1);
                    }}
                    optionFilter={filterCompany}
                    loading={isLoading}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={4} xl={5}>
                <SubCompanyFilter
                    company={filters.companyId}
                    city={filters.city}
                    value={filters.subcompanyId}
                    onChange={value => {
                        setFilters({
                            ...filters,
                            subcompanyId: value,
                            forceCourierId: undefined,
                            preferredCourierId: undefined
                        });
                        setCurrentPage(1);
                    }}
                    disabled={!filters.companyId}
                    initialCall={!!filters.companyId}
                    showAllOption={false}
                    allowClear={false}
                    showSearch={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={4} xl={2}>
                <CourierTypeFilter
                    value={filters.courierType}
                    onChange={value => {
                        setFilters({
                            ...filters,
                            courierType: value,
                            forceCourierId: undefined,
                            preferredCourierId: undefined
                        });
                        setCurrentPage(1);
                    }}
                    disabled={!filters.companyId}
                    allowClear={false}
                    showAll={false}
                    hideTitle={false}
                    filterOnly={
                        stores.appStore.companyListFilter.find(c => c._id === filters.companyId)
                            ?.courierTypes || []
                    }
                />
            </Col>
        </React.Fragment>
    );
};

export default Filters;
